import { PROMO_ID } from 'reactApp/appHelpers/featuresHelpers/features/webAutoUpload';
import { renderFakedoorModal } from 'reactApp/ui/FakedoorModal/FakedoorModal';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';

const sendRadar = createDwhTemplatedSender({ eventCategory: 'modal_autoupload_fakedoor', replacementSymbol: '_' });

export const renderWebAutoUploadFakedoorModal = () => {
    const title = 'Функция пока в разработке';
    const text = 'Спасибо – теперь знаем, что вам интересно. Сообщим сразу, как появится эта функция';
    const primaryButtonText = 'Сообщите мне';
    const secondaryButtonText = 'Закрыть';

    const onClick = () => {
        sendRadar({
            action: 'click',
        });
    };

    const onClose = () => {
        sendRadar({
            action: 'close',
        });
    };

    sendRadar({
        action: 'show',
    });

    renderFakedoorModal({
        qaId: PROMO_ID,
        title,
        text,
        primaryButtonText,
        secondaryButtonText,
        onClick,
        onClose,
    });
};
